import '@fontsource/dm-sans';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/700.css';
import '@fontsource/dm-mono';
import '@fontsource/dm-mono/500.css';

import React from 'react';
import Layout from './src/components/layout';
import { ThemeProvider } from '@mui/material';
import { theme } from './src/styles/theme';
import { redeemLoginNonceFromUrl } from './firebaseApp';
import LoginNonceOverlay from './src/components/login-nonce-overlay/login-nonce-overlay';

// Suppress the browser's PWA "install app" / "Add to Home Screen" prompt.
// gatsby-plugin-manifest generates a web app manifest (for the favicon), which
// makes mobile browsers treat the site as installable. We keep the manifest but
// stop the install banner by preventing the default beforeinstallprompt behavior.
export const onClientEntry = () => {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
  });

  // If the mobile app handed us a single-use login nonce in the URL fragment,
  // redeem it for a session. Runs as early as possible so the nonce is stripped
  // from the URL before other scripts/resources on the page can observe it.
  void redeemLoginNonceFromUrl();
};

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

export const wrapRootElement = ({ element }) => {
  return (
    <ThemeProvider theme={theme}>
      {element}
      <LoginNonceOverlay />
    </ThemeProvider>
  );
};
